'use client';

import { UserPlus, Search, CreditCard, Rocket } from 'lucide-react';
import { useTranslations } from 'next-intl';

// Icon + i18n key per step; copy lives in `public.howItWorks.steps.<key>`.
const steps = [
  { icon: UserPlus, key: 'createAccount' },
  { icon: Search, key: 'browseCourses' },
  { icon: CreditCard, key: 'enrollPay' },
  { icon: Rocket, key: 'startLearning' },
] as const;

export function HowItWorksSection() {
  const t = useTranslations('public.howItWorks');
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="font-display mb-12 text-center text-3xl font-bold text-eifo-primary md:text-4xl">
          {t('heading')}
        </h2>
        <div className="relative grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Connecting line (desktop only) */}
          <div className="absolute left-0 right-0 top-10 hidden h-0.5 border-t-2 border-dashed border-eifo-orange/30 lg:block" />

          {steps.map((step, i) => (
            <div key={step.key} className="relative flex flex-col items-center text-center">
              <div className="relative z-10 mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-eifo-orange/10 transition-transform duration-300 hover:scale-110">
                <span className="absolute -top-1 -right-1 flex h-7 w-7 items-center justify-center rounded-full bg-eifo-orange text-xs font-bold text-white">
                  {i + 1}
                </span>
                <step.icon className="h-8 w-8 text-eifo-orange" />
              </div>
              <h3 className="mb-2 text-lg font-semibold text-eifo-primary">
                {t(`steps.${step.key}.title`)}
              </h3>
              <p className="text-sm text-gray-600">{t(`steps.${step.key}.description`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
